import './UserAvatar.less';

import React from 'react';
import clsx from 'clsx';
import NotLoggedAvatar from '@/icons/NotLoggedAvatar';
import PencilIcon from 'nike-ui/src/icons/svg/pencil-icon-sv.svg';
import PopupNg from '@/ui/PopupNg';
import Avatar from '@/common/components/Avatar';

export default function UserAvatar({ avatarId, className, canChange, redactor, ...rest }) {
    function openAvatarSelector(e) {
        e.stopPropagation();
        PopupNg.dispatcher.open('selectAvatar', { avatarId });
    }

    return (
        <div className={clsx('user-avatar', className)} onClick={canChange ? openAvatarSelector : null} {...rest}>
            {avatarId ? <Avatar avatarId={avatarId} redactor={redactor} /> : <NotLoggedAvatar />}
            {canChange ? (
                <div className="change-icon">
                    <PencilIcon />
                </div>
            ) : null}
        </div>
    );
}
